import { Logger, ConfigService } from '@nextgen-web-framework/core';
import logObject from './logObject';
import isDevMachine from './isDevEnvironment';
import Configs from 'constants/configs';

const logger = Logger.getInstance(logObject('getServerUrl'));

const getServerUrl = (serviceKey: string) => {
  const configs = ConfigService.getConfigs();
  if (isDevMachine()) {
    return Configs.NEXT_PUBLIC_DEV_API_URL;
  }
  logger.log(`The value of the ssr base path is ${configs.NEXT_SSR_BASE_PATH}`);
  return `http://${serviceKey}.${configs.NEXT_SSR_BASE_PATH}`;
};

export default getServerUrl;
